import API from "../../services/api";

export const listRoles = async () => {
  const { data } = await API.get("/roles/");
  return data;
};

export const createRole = async (payload) => {
  const { data } = await API.post("/roles/", payload);
  return data;
};

export const updateRole = async (roleId, payload) => {
  const { data } = await API.put(`/roles/${roleId}`, payload);
  return data;
};

export const deleteRole = async (roleId) => {
  await API.delete(`/roles/${roleId}`);
};

export const createRolePresets = async () => {
  const { data } = await API.post("/roles/presets");
  return data;
};

export const listRoleUsers = async (roleId) => {
  const { data } = await API.get(`/roles/${roleId}/users`);
  return data;
};

export const listUsers = async () => {
  const { data } = await API.get("/users/");
  return data;
};

export const listUserRoles = async (userId) => {
  const { data } = await API.get(`/users/${userId}/roles`);
  return data;
};

export const assignUserRole = async (payload) => {
  const { data } = await API.post("/user-roles/", payload);
  return data;
};

export const unassignUserRole = async (userRoleId) => {
  await API.delete(`/user-roles/${userRoleId}`);
};
